/**
 * The app's footer (Arjun's notes after the 2026-10-06 deploy): the last thing in every page's scroll, under its
 * content, never fixed. Who makes it and the product's name, the build it is, and where to find help and the legal
 * pages. On a short page it sits at the window's foot (the shell's main column grows the page to fill it). On paper the
 * links are left out; the line who makes it stays.
 */
import { Link } from "react-router-dom";
import { BUILT_ON, footerLine } from "@/lib/nav/footer";

const LINK = "underline-offset-4 hover:text-on-surface hover:underline";

export function AppFooter({
  productName,
  year = new Date().getFullYear(),
  builtOn = BUILT_ON,
}: {
  productName: string;
  year?: number;
  builtOn?: string;
}) {
  return (
    <footer className="shrink-0 border-t border-border px-4 py-4 text-xs text-on-surface-muted md:px-8">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-x-6 gap-y-2">
        <p>{footerLine(productName, year, builtOn)}</p>
        <nav aria-label="Footer" data-no-print="">
          <ul className="flex flex-wrap gap-x-4 gap-y-1">
            <li>
              <Link to="/app/settings?tab=help" className={LINK}>
                Help and tutorials
              </Link>
            </li>
            <li>
              <Link to="/privacy" className={LINK}>
                Privacy
              </Link>
            </li>
            <li>
              <Link to="/terms" className={LINK}>
                Terms
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}
